$(document).ready(function(){
    function inputValidationFAC(){
        var settings = {
            DEFAULT_DECIMAL_SEPARATOR: '.',
            NEGATIVE_CHAR: '-',
            REVERSE_DECIMAL_SEPARATOR_OFFSET: 5,
            INPUT_MAX_LENGTH_WHOLE_NUMBER: 14,
            DECIMAL_PRECISION: 4
        };

        var cleanNegativeNumber = function(value){
            value = value.substring(1).replace(/-/g,'');
            if(isNaN(value.split('')[0])){
              value = value.substring(1);
            }
            return value;
        };

        var validateNumber = function(value, maxLength){
            if(value.length > maxLength){
                return value.substring(0,maxLength);
            }
            return value;
        };

        var parseNumber = function(number){
            return number.replace(/[^0-9-]/g,'');
        };

        var parseDecimal = function(number){
            return number.replace(/[^0-9]/g,'');
        };

        return{
            getDecimalSeparator: function(maskingFormat){
                if(maskingFormat){
                    return maskingFormat.charAt(maskingFormat.length - settings.REVERSE_DECIMAL_SEPARATOR_OFFSET);
                }
            },
            validateInput: function(value, options){
                var isValid = true;
                if(value){
                    var wholeNumber =  value;
                    var numberParts = wholeNumber.split(options.decimalSeparator);
                    var wholeNumberLength = wholeNumber.indexOf('-') >= 0 ? settings.INPUT_MAX_LENGTH_WHOLE_NUMBER + 1 : settings.INPUT_MAX_LENGTH_WHOLE_NUMBER;
                    if(numberParts.length === 2){
                        isValid = (parseNumber(numberParts[0]).length <= wholeNumberLength);
                        isValid &= (parseNumber(numberParts[1]).length <= settings.DECIMAL_PRECISION);
                    }else if(numberParts.length === 1){
                        isValid = parseNumber(wholeNumber).length <= wholeNumberLength;
                    } else{
                        isValid = false;
                    }
                }
                return isValid;
            },
            cleanModel: function(value, options, __decimalSeparator){
                var wholeNumber = value;
                var numberParts = wholeNumber.split(__decimalSeparator || options.decimalSeparator);
                var wholeNumberLength = wholeNumber.indexOf('-') >= 0 ? settings.INPUT_MAX_LENGTH_WHOLE_NUMBER + 1 : settings.INPUT_MAX_LENGTH_WHOLE_NUMBER;
                if(numberParts.length === 2){
                    //decimal number 
                    wholeNumber = validateNumber(parseNumber(numberParts[0]), wholeNumberLength);
                    decimalValue = validateNumber(parseDecimal(numberParts[1]), settings.DECIMAL_PRECISION);
                    return wholeNumber.concat('.',decimalValue);
                }else{
                    return validateNumber(parseNumber(wholeNumber), wholeNumberLength);
                }
            },
            formatView: function(value, options){
                var decimalOffset = -1,
                    wholeNumber = value,
                    decimalValue = '',
                    negativeChar='',
                    decimalSeparator='';

                //check for negative number and keep the sign
                if(value.indexOf(settings.NEGATIVE_CHAR) === 0){
                    negativeChar = settings.NEGATIVE_CHAR;
                    if(value.indexOf(settings.DEFAULT_DECIMAL_SEPARATOR) !== 1){
                        wholeNumber = cleanNegativeNumber(value);
                    }
                }
                if(wholeNumber){
                    var numberParts = wholeNumber.split(settings.DEFAULT_DECIMAL_SEPARATOR);
                    if(numberParts.length === 2){
                        //decimal number 
                        wholeNumber = parseDecimal(numberParts[0]);
                        decimalValue = parseDecimal(numberParts[1]);
                        decimalSeparator = options.decimalSeparator;
                    }

                    //generate mask
                    var tempElem = $('<input type="text" />');
                    $(tempElem).val(wholeNumber);
                    $(tempElem).mask(options.maskFormat, {
                        reverse: options.reverse
                    });
                    wholeNumber = $(tempElem).trigger('input').val();
                    return negativeChar + wholeNumber + decimalSeparator + decimalValue;
                }
                return value;
            }
        };
    }

    function maskingOptionFAC(format){
        var maskFormat = format.substring(0, format.length-5);
        var DECIMAL_SEPARATOR = inputValidationFAC().getDecimalSeparator(format);
        var PATTERN = new RegExp("[0-9\\" + DECIMAL_SEPARATOR + "-]");

        return {
            watchInterval: 100,
            decimalSeparator: DECIMAL_SEPARATOR,
            reverse: true,
            translation: {
                '#': {
                    pattern: PATTERN,
                    recursive: true
                }
            },
            maskPattern: PATTERN,
            maskFormat: maskFormat,
            format: format,
            formatter: inputValidationFAC().formatView,
            cleanVal: inputValidationFAC().cleanModel,
            validateInput: inputValidationFAC().validateInput
        };
    }

    if(window.isNumberFormatEnabled){
        var format = (window._jvselfUser && _jvselfUser.locale && _jvselfUser.locale.numberFormat ) ? _jvselfUser.locale.numberFormat  : '##########';
        var $fields = $(".numberFormatMasking");
        var options = maskingOptionFAC(format);

        // apply masking logic to every field
        $fields.each(function(){
            var mainElement = $(this);
            var clone = mainElement.clone().attr('name', '');
            mainElement.after(clone).hide();

            var updateValue = function(elem, value, options, __decimalSeparator){
                var _cleanValue = options.cleanVal(value, options, __decimalSeparator);
                var _value = options.formatter(_cleanValue, options);
                $(clone).val(_value);
                $(clone).text(_value);
                $(mainElement).val(_cleanValue);
            };

            if(mainElement.is(':input')){
                $(clone).on('change input', function(e){
                    var _value = $(clone).val();
                    updateValue(clone, _value, options);    
                });
                
                $(clone).on('blur', function(e){
                    var value = $(clone).val();
                    if(isNaN(value.split('').pop())){
                        $(clone).val(value.substring(0, value.length-1)).trigger('input');
                    }
                });

                $(clone).on('keypress', function(e){
                    var currentValue = this.value.  substring(0, this.selectionStart) + String.fromCharCode(e.which) + this.value.substring(this.selectionStart);
                    if(!options.validateInput(currentValue, options)){
                        e.preventDefault();
                    }
                });

                if($(clone).val()){
                    updateValue(clone, $(clone).val(), options, '.');
                    $(clone).trigger('change');
                }
            } else{
                updateValue(clone, $(mainElement).text(), options,'.');
            }
        });
    }
});